import { useRouter } from "next/router"
import React, { useCallback } from "react"

import { Links } from "../../../config/links"
import { Box } from "../box"
import { ClientOnly } from "../client-only"
import { BitsGradientIcon } from "../icons/bits-gradient-icon"
import { OilsGradientIcon } from "../icons/oils-gradient-icon"
import { Plus } from "../icons/plus"
import { PolygonIcon } from "../icons/polygon-icon"

type BalanceProp = {
  value: number | string
  className?: string
  token: "BITS" | "OIL" | "MATIC"
}

const icons = {
  BITS: BitsGradientIcon,
  OIL: OilsGradientIcon,
  MATIC: PolygonIcon,
}

export function Balance({ token, value, className }: BalanceProp) {
  const router = useRouter()
  const Icon = icons[token]

  const handleClickToPlus = useCallback(() => {
    if (token === "MATIC") {
      router.push(Links.WALLET_DASHBOARD_DEPOSIT_MATIC + "&value=10")
      return
    }

    if (token === "OIL") {
      router.push(Links.WALLET_DASHBOARD_SWAP_OIL)
      return
    }
    if (token === "BITS") {
      router.push(Links.WALLET_DASHBOARD_SWAP_BITS)
      return
    }
  }, [router, token])

  return (
    <div className={["flex text-white", className].join(" ")}>
      <Box
        row
        className="flex h-[2rem] items-center justify-center overflow-hidden rounded-l-lg bg-[#0000004D] py-1 pl-2 pr-1"
      >
        <Icon className="h-5" w={14} h={14} />
        <ClientOnly>
          <div className="m-auto ml-1 min-w-[3.4rem] text-center text-[1rem] font-bold leading-none lg:min-w-[4rem]">
            {value}
          </div>
        </ClientOnly>
      </Box>

      <Box
        onClick={handleClickToPlus}
        row
        center
        className="ml-0.5 h-[2rem] overflow-hidden rounded-r-lg bg-[#0000004D] px-1.5 py-1"
      >
        <div className="font text-center font-bold">
          <Plus fill="#F0DCFF" className="h-[0.8rem]" />
        </div>
      </Box>
    </div>
  )
}
